@if (result !== null && result !== undefined) {
<fieldset class="pb-3 lp-result-panel">
    <legend class="form-row p-2 pl-3 mb-0" [ngClass]="legendClass">
        <p class="mb-0 d-flex align-items-center">
            <strong>AI least-privilege review</strong>
            @if (badgeLabel) {
                <span class="lp-badge ms-2">{{ badgeLabel }}</span>
            }
        </p>
    </legend>

    <div class="lp-result-body">

        <!-- Agree -->
        @if (result.decisionType === 'Agree') {
        <p class="lp-section-title">Permissions align with the stated justification:</p>
        @for (p of result.recommendedPermissions; track p.name) {
        <div class="lp-permission-row lp-row-agree">
            <span class="lp-perm-name">{{ p.name }}</span>
            <span class="lp-perm-type">{{ p.isDelegated ? 'delegated' : 'application' }}</span>
            <span class="lp-perm-reason">{{ p.reason }}</span>
        </div>
        }
        <p class="lp-explanation">{{ result.explanation }}</p>
        }

        <!-- RecommendDifferent -->
        @else if (result.decisionType === 'RecommendDifferent') {
        @if (result.recommendedPermissions.length > 0) {
        <p class="lp-section-title">Suggested least-privilege permissions:</p>
        @for (p of result.recommendedPermissions; track p.name) {
        <div class="lp-permission-row lp-row-suggest">
            <span class="lp-perm-name">{{ p.name }}</span>
            <span class="lp-perm-type">{{ p.isDelegated ? 'delegated' : 'application' }}</span>
            <span class="lp-perm-reason">{{ p.reason }}</span>
        </div>
        }
        }
        @if (result.excludedPermissions.length > 0) {
        <p class="lp-section-title lp-section-title-exclude">Permissions to remove:</p>
        @for (p of result.excludedPermissions; track p.name) {
        <div class="lp-permission-row lp-row-exclude">
            <span class="lp-perm-name">{{ p.name }}</span>
            <span class="lp-perm-reason">{{ p.reason }}</span>
        </div>
        }
        }
        <p class="lp-explanation">{{ result.explanation }}</p>
        }

        <!-- Clarify -->
        @else if (result.decisionType === 'Clarify') {
        <p class="lp-section-title">The following clarifications are needed before this request can proceed:</p>
        <ul class="lp-questions">
            @for (q of result.clarificationQuestions; track q) {
            <li>{{ q }}</li>
            }
        </ul>
        <p class="lp-explanation">{{ result.explanation }}</p>
        }

    </div>
</fieldset>
}
